import { Injectable } from '@angular/core';
import { Keyboard, KeyboardInfo } from '@capacitor/keyboard';
import { KeyboardHelper } from '@core/helpers/keyboard.helper';
import { map, Observable, Subject } from 'rxjs';

type KeyboardEvent = { type: 'keyboardDidShow'; info: KeyboardInfo } | { type: 'keyboardDidHide' };

@Injectable({
  providedIn: 'root',
})
export class NativeKeyboardService {
  #keyboardEvent = new Subject<KeyboardEvent>();
  #keyboardEvent$ = this.#keyboardEvent.asObservable();

  public constructor() {
    this.initKeyboardListeners();
  }

  public autoScrollToElementIfHiddenByKeyboard(elementToAdjustSelector?: () => Element): Observable<void> {
    return this.#keyboardEvent$.pipe(
      map((e: KeyboardEvent) => {
        const elementToAdjust = elementToAdjustSelector?.() ?? document.activeElement ?? undefined;
        switch (e.type) {
          case 'keyboardDidShow':
            KeyboardHelper.adjustUIForKeyboard(e.info.keyboardHeight, elementToAdjust);
            break;
          case 'keyboardDidHide':
            KeyboardHelper.resetUIAfterKeyboard(elementToAdjust);
            break;
        }
      }),
    );
  }

  private initKeyboardListeners(): void {
    Keyboard.addListener('keyboardDidShow', info => this.#keyboardEvent.next({ type: 'keyboardDidShow', info }));
    Keyboard.addListener('keyboardDidHide', () => this.#keyboardEvent.next({ type: 'keyboardDidHide' }));
  }
}
